/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { KTSVG } from '../../../../_metronic/helpers'
import './VisaListRecordCount.css'
import { getvisadashborddata } from '../core/_requests'
import { VisaDashboardQueryResponce } from '../core/_models'
import { object } from 'yup'



type Props = {
    className?: string
    heading?: string
    total_count?: string
    route_heading?: string
    data?: any
    name?: string
    count?: any
    inq_today_pending?: number
    inq_past_pending?: number
    inq_future_pending?: number
    inq_completed_task?: number
    today_followup?: number
    followup_past_active?: number


    today_task?: number
    filter?: any
}

const ToDoListRecord: React.FC<Props> = ({ className, heading, count, data, inq_today_pending, inq_past_pending, inq_future_pending, inq_completed_task, today_followup, today_task, filter, name, followup_past_active }) => {
    function removeEmptyPairs(filter: any) {
        if (filter === undefined || filter === null) {
            return '';
        }
        const pairs = filter.split('&');
        // console.log('pair',pairs)
        const nonEmptyPairs = pairs.filter((pair: any) => {
            const [key, value] = pair.split('=');
            return value !== '';
        });
        // console.log('nonempty',nonEmptyPairs)
        const filteredFilter = nonEmptyPairs.join('&');

        return filteredFilter;
    }
    const filteredFilter = removeEmptyPairs(filter);
    // console.log('filter_foll',filteredFilter)

    const hasMatchingKey = filteredFilter.split('&').some((pair: any) => {
        const [key] = pair.split('=');
        return key === name;
    });
    let newFilteredFilter = filteredFilter;

    if (hasMatchingKey) {
        const pairs = newFilteredFilter.split('&');
        newFilteredFilter = pairs
            .filter((pair: any) => {
                const [key] = pair.split('=');
                return key !== name;
            })
            .join('&');
    }

    // const currentPath = window.location.pathname + window.location.search;

    // console.log('originalUrl', currentPath)
    // Function to update the URL with a new query parameter
    const updateURL = (paramName: any, paramValue: any) => {
        if (window.location.search === '') {
            console.log('paramValue', paramValue)
            const currentPath = window.location.pathname + window.location.search;
            const newURL = `${currentPath}?${paramName}=${paramValue}`;
            window.open(newURL);
        } else {
            const currentPath = window.location.pathname + window.location.search;
            const newURL = `${currentPath}&${paramName}=${paramValue}`;
            window.open(newURL);
        }
    };

    const handleItemClick = (e: any, obj: any) => {
        e.preventDefault();
        updateURL(name, obj);
    };

    console.log('hasMatchingKey_follow', hasMatchingKey)

    return (
        <div className={`card ${className}`}>
            <div className='card-header border-0'>
                <h3 className='card-title fw-bold text-dark'>{heading}</h3>
                {/* <div className='card-toolbar'>
                    <button
                        type='button'
                        className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
                        data-kt-menu-trigger='click'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                    >
                        <KTSVG path='/media/icons/duotune/arrows/arrow-up-right-square-fill.svg' className='svg-icon-2' />
                    </button>
                </div> */}
            </div>

            <div className='card-body pt-4 custom-fixed-height'>
                <div >
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Today's Pending Task"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{inq_today_pending}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}task-management/list?visa_task_option=inq_today_pending`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}\
                            <span className={`svg-icon svg-icon-2`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                    <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                </svg>
                            </span>
                        </a>
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Past Pending Task"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{inq_past_pending}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}task-management/list?visa_task_option=inq_past_pending`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}
                            <span className={`svg-icon svg-icon-2`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                    <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                </svg>
                            </span>
                        </a>
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Future Pending Task"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{inq_future_pending}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}task-management/list?visa_task_option=inq_future_pending`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}
                            <span className={`svg-icon svg-icon-2`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                    <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                </svg>
                            </span>                        </a>
                    </div>
                    <div className='d-flex align-items-center mb-5 border-bottom border-secondary'>
                        <span className='bullet bullet-vertical h-30px bg-success mb-1'></span>
                        <div className='flex-grow-1 mx-8 '>

                            <a className='text-gray-800 text-hover-primary fw-bold fs-6'>
                                {"Total Completed Task"}
                            </a>
                        </div>
                        <span className='fw-bold badge badge-primary d-block me-2'>{inq_completed_task}</span>

                        <a href={`${process.env.REACT_APP_HOME_PAGE}task-management/list?visa_task_option=inq_completed_task`} target='_blank' type='button' className='btn btn-sm btn-icon btn-color-success btn-active-light-success'>
                            {/* <KTSVG path='/media/icons/duotune/general/gen057.svg' className='svg-icon-2' /> */}
                            <span className={`svg-icon svg-icon-2`}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="5" fill="currentColor" />
                                    <path d="M11.9343 12.5657L9.53696 14.963C9.22669 15.2733 9.18488 15.7619 9.43792 16.1204C9.7616 16.5789 10.4211 16.6334 10.8156 16.2342L14.3054 12.7029C14.6903 12.3134 14.6903 11.6866 14.3054 11.2971L10.8156 7.76582C10.4211 7.3666 9.7616 7.42107 9.43792 7.87962C9.18488 8.23809 9.22669 8.72669 9.53696 9.03696L11.9343 11.4343C12.2467 11.7467 12.2467 12.2533 11.9343 12.5657Z" fill="currentColor" />
                                </svg>
                            </span>
                        </a>
                    </div>

                </div>

            </div>
        </div>
    )
}

export { ToDoListRecord }
